// extracted by mini-css-extract-plugin
export default {"wrap":"WI-z","subtitle":"XI-z","contentWrap":"YI-z","imgWrap":"ZI-z","heading":"_I-z","copy":"aJ-z"};